
import React, { useEffect, useState } from 'react';
import { BackendWrapper, PickerHOC, View } from '@coinscrap/webapp-core';

import { useGetUniqueToken } from 'hooks/useGetUniqueToken';

import { Loader } from '../../../../components/Loader/Loader';

export const GlobalAgent = PickerHOC()(({ agentUser }) => {
	const { getInstanceApi } = BackendWrapper.use();

	const [iframeSrc, setiframeSrc] = useState(undefined);
	const [loadedIframe, setloadedIframe] = useState(false);
	const [instance, setInstance] = useState(undefined);

	useEffect(() => {
		// declare the async data fetching function
		const fetchInstance = async () => {
			const fetchedinstance = await getInstanceApi();
			setInstance(fetchedinstance);
		};

		fetchInstance().catch(console.error);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getUniqueToken = useGetUniqueToken(agentUser?.id, instance);
	// console.log('getUniqueToken', getUniqueToken);

	useEffect(() => {
		const fetchUniqueIdentifier = async () => {
			const uniqueToken = await getUniqueToken();
			// console.log('uniqueToken', uniqueToken);
			setiframeSrc(window?.__CLIENT_ENV?.CLIENT_ENV_DASHBOARD_VR_BASE_URL + uniqueToken);
		};

		if (instance && !iframeSrc) {
			fetchUniqueIdentifier().catch(console.error);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [instance, iframeSrc]);

	return (
		<View style={{ width: '100%' }} justifyStartSt>
			{!loadedIframe && (
				<View style={{ display: 'flex', width: 'initial', marginTop: '3rem' }}>
					<Loader type="regular" loadingText={'Cargando'} />
				</View>
			)}
			{iframeSrc && (
				<iframe
					src={iframeSrc}
					width={'100%'}
					height={'1050px'}
					style={{ border: 'none', marginBottom: '40px' }}
					title="Dashboard"
					onLoad={() => {
						setloadedIframe(true);
					}}
				/>
			)}
		</View>
	);
});
